import { render, staticRenderFns } from "./Lgx335452482824044544.vue?vue&type=template&id=89f50c48&scoped=true&"
import script from "./Lgx335452482824044544.vue?vue&type=script&lang=js&"
export * from "./Lgx335452482824044544.vue?vue&type=script&lang=js&"
import style0 from "./Lgx335452482824044544.vue?vue&type=style&index=0&id=89f50c48&prod&lang=scss&scoped=true&"
import style1 from "./Lgx335452482824044544.vue?vue&type=style&index=1&id=89f50c48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f50c48",
  null
  
)

export default component.exports